import { types } from 'mobx-state-tree'
import * as layersData from 'src/constants/layers'
import {
  ILayersInstance,
  ILayersDataNumberValues,
  ILayersDataKeys,
  ILayersDataEntries,
  ILayerIdentifier,
  ILayerSwitchArg,
  ILayersProps,
  ILayersModel
} from 'src/api/misc/Layers/types'

const layersProp = types.optional(types.boolean, true)

const layersKeys: Array<ILayersDataNumberValues> = []
const layersNames: Partial<{ [key in ILayersDataKeys]: ILayersDataNumberValues }> = {}
const layers: Partial<{ [key in ILayersDataNumberValues]: typeof layersProp }> = {}
const layersActions: Partial<{ [key in ILayersDataKeys]: number | number[] }> = {}
;(Object.entries(layersData) as ILayersDataEntries).forEach(([name, data]) => {
  if (typeof data === 'number') {
    layersKeys.push(data as ILayersDataNumberValues)
    layers[data as ILayersDataNumberValues] = layersProp
    layersActions[name] = data
  } else if (Array.isArray(data)) {
    layersActions[name] = data
  }
})

const getLayerNumbers = (layerIdentifier: ILayersDataKeys): ILayersDataNumberValues[] => {
  const data = layersNames[layerIdentifier]
  if (Array.isArray(data)) {
    return data
  }
  return data ? [data] : []
}

const handler = (self: ILayersInstance, fnName: 'disable' | 'enable') => (
  args: ILayerSwitchArg
) => {
  if (Array.isArray(args) || typeof args === 'string') {
    if (Array.isArray(args)) {
      args.forEach((arg: ILayerIdentifier) => {
        if (typeof arg === 'string') {
          const keys = getLayerNumbers(arg)
          keys.forEach(key => self[fnName](key))
        } else {
          self[fnName](arg)
        }
      })
    } else {
      const keys = getLayerNumbers(args)
      keys.forEach(key => self[fnName](key))
    }
  } else if (typeof args === 'number') {
    self[args] = true
  } else if (typeof args === 'object') {
    const keys: ILayersDataNumberValues[] = []
    if (Array.isArray(args.layers)) {
      args.layers.forEach((layer: ILayersDataKeys | ILayersDataNumberValues) =>
        typeof layer === 'number' ? keys.push(layer) : keys.push(...getLayerNumbers(layer))
      )
    } else {
      const layer = args.layers
      typeof layer === 'number' ? keys.push(layer) : keys.push(...getLayerNumbers(layer))
    }
    if (args.exclusive) {
      layersKeys.forEach(layersKey =>
        keys.includes(layersKey)
          ? self[fnName](layersKey)
          : self[fnName === 'enable' ? 'disable' : 'enable'](layersKey)
      )
    }
  }
}

const actions = (self: ILayersInstance) => ({
  enable: handler(self, 'enable'),
  enableAll() {
    layersKeys.forEach(layersKey => (self[layersKey] = true))
  },
  disable: handler(self, 'disable'),
  disableAll() {
    layersKeys.forEach(layersKey => (self[layersKey] = false))
  }
})

export const Layers = types
  .model('Layers', layers as ILayersProps)
  .actions(actions as any) as ILayersModel
